import {
  Box,
  Button,
  FormLabel,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import { OptionsObject, useSnackbar } from "notistack";
import SignalCellularAlt1BarIcon from "@mui/icons-material/SignalCellularAlt1Bar";
import SignalCellularAlt2BarIcon from "@mui/icons-material/SignalCellularAlt2Bar";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import { useState } from "react";
import { reportBug, requestFeature } from "../../api/feedback/FeedbackAPI";
import {
  AlertErrorProp,
  AlertSuccessProp,
} from "../../components/SnackbarNoti";
import { purpleCTA } from "../../components/ColorDefs";
import { useTranslation } from "react-i18next";

function FeedbackPage() {
  const { t } = useTranslation(["common"]);
  const feedbackTypes = [
    { display: t("Report_errors"), value: "bug" },
    { display: t("Request_features"), value: "feature" },
  ];
  const bugSeverities = [
    {
      display: (
        <div className="icon-menu-item">
          {t("common:Low")} <SignalCellularAlt1BarIcon sx={{ fill: "green" }} />
        </div>
      ),
      value: "LOW",
    },
    {
      display: (
        <div className="icon-menu-item">
          {t("common:Medium")}{" "}
          <SignalCellularAlt2BarIcon sx={{ fill: "gold" }} />
        </div>
      ),
      value: "MEDIUM",
    },
    {
      display: (
        <div className="icon-menu-item">
          {t("common:High")} <SignalCellularAltIcon sx={{ fill: "red" }} />
        </div>
      ),
      value: "HIGH",
    },
  ];

  const bugTypes = [
    {
      display: t("common:User_interface"),
      value: "FRONTEND",
    },
    {
      display: t("common:Data"),
      value: "DATA",
    },
  ];

  const [chosenReportType, setChosenReportType] = useState("bug");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [bugType, setBugType] = useState("FRONTEND");
  const [bugSeverity, setBugSeverity] = useState("LOW");
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (chosenReportType == "bug") {
      var bugRequest = {
        title: title,
        message: content,
        bugSeverity: bugSeverity,
        bugType: bugType,
      };
      reportBug(bugRequest)
        .then((res) => {
          setTitle("");
          setContent("");
          enqueueSnackbar(
            "Your bug report has been recorded. Thanks for letting us know",
            AlertSuccessProp as OptionsObject
          );
        })
        .catch((err) => {
          enqueueSnackbar(
            "The server can not proceed this request right now, try again later",
            AlertErrorProp as OptionsObject
          );
        });
    } else {
      var featureRequest = {
        title: title,
        message: content,
      };
      requestFeature(featureRequest)
        .then((res) => {
          setTitle("");
          setContent("");
          enqueueSnackbar(
            "Your feature request has been recorded. Thanks for giving us ideas",
            AlertSuccessProp as OptionsObject
          );
        })
        .catch((err) => {
          enqueueSnackbar(
            "The server can not proceed this request right now, try again later",
            AlertErrorProp as OptionsObject
          );
        });
    }
  };

  var menuFeedbackItems = feedbackTypes.map(function (e) {
    return <MenuItem value={e.value}>{e.display}</MenuItem>;
  });

  var menuBugSeverityItems = bugSeverities.map(function (e) {
    return <MenuItem value={e.value}>{e.display}</MenuItem>;
  });

  var menuBugTypeItems = bugTypes.map(function (e) {
    return <MenuItem value={e.value}>{e.display}</MenuItem>;
  });
  return (
    <Grid container sx={{marginTop: "4vh"}}>
      <Grid item xs={2}></Grid>
      <Grid
        item
        padding={4}
        xs={8}
        className="grid-border no-scale slide-from-bottom white"
      >
        <Typography variant="h5" fontWeight={600}>
          {t("common:Feedback_page")}
        </Typography>
        <Box component="form" noValidate sx={{ mt: 2 }}>
          <div style={{ textAlign: "left" }}>
            <FormLabel required sx={{ textAlign: "left" }}>
              {" "}
              {t("common:Type_of_feedback")}
            </FormLabel>
          </div>

          <Select
            label={t("common:Type_of_feedback")}
            variant="standard"
            value={chosenReportType}
            fullWidth
            sx={{ textAlign: "left" }}
            onChange={(event: SelectChangeEvent) => {
              setChosenReportType(event.target.value as string);
            }}
          >
            {menuFeedbackItems}
          </Select>
          <div style={{ textAlign: "left", marginTop: "20px" }}>
            <FormLabel required sx={{ textAlign: "left" }}>
              {" "}
              {t("common:Topic")}
            </FormLabel>
          </div>
          <TextField
            variant="standard"
            margin="normal"
            required
            fullWidth
            value={title}
            sx={{ marginTop: "0px" }}
            onChange={(e) => {
              setTitle((e.target as HTMLInputElement).value);
            }}
          ></TextField>
          <div style={{ textAlign: "left", marginTop: "20px" }}>
            <FormLabel required sx={{ textAlign: "left" }}>
              {" "}
              {t("common:Content")}
            </FormLabel>
          </div>
          <TextField
            variant="standard"
            margin="normal"
            required
            fullWidth
            multiline
            rows={2}
            maxRows={2}
            sx={{ marginTop: "0px" }}
            value={content}
            onChange={(e) => {
              setContent((e.target as HTMLInputElement).value);
            }}
          ></TextField>
          {chosenReportType == "bug" ? (
            <div style={{ textAlign: "left", marginTop: "20px" }}>
              <FormLabel sx={{ textAlign: "left" }}>
                {" "}
                {t("common:Level_of_severity")}
              </FormLabel>
              <Select
                label="Mức độ nghiêm trọng"
                variant="standard"
                value={bugSeverity}
                fullWidth
                sx={{ textAlign: "left" }}
                onChange={(event: SelectChangeEvent) => {
                  setBugSeverity(event.target.value as string);
                }}
              >
                {menuBugSeverityItems}
              </Select>
            </div>
          ) : (
            ""
          )}

          {chosenReportType == "bug" ? (
            <div
              style={{
                textAlign: "left",
                marginTop: "30px",
                marginBottom: "20px",
              }}
            >
              <FormLabel sx={{ textAlign: "left" }}>
                {" "}
                {t("common:Type_of_error")}
              </FormLabel>
              <Select
                label="Loại lỗi"
                variant="standard"
                value={bugType}
                fullWidth
                sx={{ textAlign: "left" }}
                onChange={(event: SelectChangeEvent) => {
                  setBugType(event.target.value as string);
                }}
              >
                {menuBugTypeItems}
              </Select>
            </div>
          ) : (
            ""
          )}
          <Button
            type="submit"
            fullWidth
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {t("common:Submit")}
          </Button>
        </Box>
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
}
export default FeedbackPage;
